import ReceiptFromProductionCaseSource from '@/models/ReceiptFromProductionCaseSource/ReceiptFromProductionCaseSource';

export default class ReceiptFromProductionCaseSourceFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.receiptFromProductionCaseId  = '';
		this.receiptFromProductionCaseControlCard = '';
		this.receiptFromProductionMaterialId  = '';
		this.receiptFromProductionMaterialControlCard = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.qtyTaken = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			receiptFromProductionCaseId : '0',
			receiptFromProductionCaseControlCard : '0',
			receiptFromProductionMaterialId : '0',
			receiptFromProductionMaterialControlCard : '0',
			partId : '0',
			partPartNumber : '0',
			qtyBefore : '0',
			qtyAfter : '0',
			qtyTaken : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}